import { EntityType } from '@shared/models/entity-enum';
import { ClipboardSearchConfigByEntity } from './clipboard-search-state.model';

export const getUsagesInRecord = (record: Record<string, any>) =>
  (record.data?.usages || []).map((usageData: Record<string, any>) => usageData?.ref_property_usage_type_desc);

export const getUsagesInDataSet = (recordsList: Record<string, any>[]) => {
  const allUsages = recordsList.map(getUsagesInRecord).flat();
  return Array.from(new Set(allUsages));
};

export const getSearchStateFormattedToBeSaveByListOfUsages = (usages: string[]) => ({
  simplifyDataByUsageType: usages,
});

export const getSearchStateFormattedToBeSave = (
  newUsagesList: string[],
  searchStateParams: ClipboardSearchConfigByEntity,
  entity: EntityType
) => {
  // Always keep existing params for LeaseComp
  if (entity === EntityType.LeaseComp) return searchStateParams;

  if (entity !== EntityType.Property || isCustomAllOptionSelected(searchStateParams)) {
    return;
  }

  // Remove from the selected usages the ones that are no longer part of the data set
  const newSelectedUsages = searchStateParams.simplifyDataByUsageType.filter(u => newUsagesList.includes(u));
  return getSearchStateFormattedToBeSaveByListOfUsages(newSelectedUsages);
};

export const isCustomAllOptionSelected = (searchStateParams: ClipboardSearchConfigByEntity) =>
  searchStateParams?.simplifyDataByUsageType == null || searchStateParams?.simplifyDataByUsageType?.length == 0;

export const customOptionHaveChange = (currentValues: string[], newValues: string[]) => {
  if ((newValues == null && currentValues != null) || currentValues.length !== newValues.length) {
    return true;
  }

  const newValuesThatAreNotSelected = newValues.filter(v => !currentValues.includes(v));
  const currentValuesThatAreNotSelected = currentValues.filter(v => !newValues.includes(v));
  return newValuesThatAreNotSelected.length > 0 || currentValuesThatAreNotSelected.length > 0;
};
